import { createRequiredContext } from 'src/context/createRequiredContext';

import { useInviteSlice } from './useInviteSlice';

const [useInvite, InviteProvider] = createRequiredContext<ReturnType<typeof useInviteSlice>>();

const InviteContextProvider = ({ children }: React.PropsWithChildren) => {
  const inviteSlice = useInviteSlice();

  return <InviteProvider value={inviteSlice}>{children}</InviteProvider>;
};

export { useInvite, InviteContextProvider };
